module.exports = __webpack_public_path__ + "~@/assets/img/ping.3faf0ad3.png";